import PropTypes from 'prop-types';

export const scholarshipPropType = PropTypes.shape({
  FUNDAWARDS: PropTypes.arrayOf(
    PropTypes.shape({
      AMOUNT: PropTypes.string,
      FISCALYEAR: PropTypes.string,
    })
  ),
  FUNDDETAILS: PropTypes.shape({
    INHONORORMEMORYOF: PropTypes.string,
    PURPOSE: PropTypes.string,
  }),
  FUNDNAME: PropTypes.string,
  FUNDPURPOSEID: PropTypes.string,
  FUNDTHANKYOUNOTES: PropTypes.shape({
    ISREVIEWED: PropTypes.bool,
  }),
  FUND_DONORS: PropTypes.arrayOf(
    PropTypes.shape({
      NAME: PropTypes.string,
      FIRSTNAME: PropTypes.string,
      LASTNAME: PropTypes.string,
      LOOKUPID: PropTypes.string,
      HAS_PHOTO: PropTypes.bool,
      IS_FOUNDATION: PropTypes.bool,
      FOUNDATION_URL: PropTypes.string,
    })
  ),
});

export default {};
